import { createFileRoute, redirect } from '@tanstack/react-router';
import { validateDrawerSearch, validateLocationSearch } from '@/features/locations/search';

/** Sections of the location page that used to be tabs (/app/locations/$id/<tab>). */
const FORMER_TABS: Record<string, string | undefined> = {
  files: 'files',
  conversations: 'conversations',
  data: 'facts',
  history: 'history',
  contacts: 'people',
  automation: undefined,
};

/** Every old /app/locations/... address moves to the same place under /app/board. */
export const Route = createFileRoute('/app/locations/$')({
  beforeLoad: ({ params, location }) => {
    const raw = location.search as Record<string, unknown>;
    const [first, second, ...rest] = (params._splat ?? '').split('/').filter(Boolean);
    if (!first || rest.length > 0) throw redirect({ to: '/app/board', search: validateLocationSearch(raw), replace: true });
    if (first === 'new' && !second) throw redirect({ to: '/app/board/new', replace: true });
    if (!second) throw redirect({ to: '/app/board/$locationId', params: { locationId: first }, search: validateDrawerSearch(raw), replace: true });
    if (second === 'edit') throw redirect({ to: '/app/board/$locationId/edit', params: { locationId: first }, replace: true });
    if (second in FORMER_TABS) {
      throw redirect({ to: '/app/board/$locationId', params: { locationId: first }, hash: FORMER_TABS[second], replace: true });
    }
    throw redirect({ to: '/app/board/$locationId', params: { locationId: first }, replace: true });
  },
});
